import { getAncillaries } from "../../../store/flightDetails/selectors.js";
import { createTrackingUtils } from "../index.js";
import useProfiler from "../../../hooks/useProfiler.js";
import { useSelector } from "react-redux";
const utils = createTrackingUtils({
    name: "flights_funnel_baggage_in_pax_mobile_2",
    defaultStage: 2,
    stages: {
        flight_details: 1,
        main: 2,
        direct: 3,
        meta: 4,
        non_bf_flow: 5,
        families: 6,
        long_haul: 7,
        has_extra_baggage: 8,
        has_no_extra_baggage: 9
    },
    goals: {
        click_on_baggage_cta: 1
    }
});
export const useTrackExtrasStageBaggageInPaxMobile = () => {
    const ancillaries = useSelector(getAncillaries);
    const { isMobile } = useProfiler();
    return () => {
        if (!isMobile()) {
            return;
        }
        const isExtraAvailable = !!ancillaries?.checkedInBaggage || !!ancillaries?.cabinBaggagePerTraveller;
        if (isExtraAvailable) {
            utils.stages.has_extra_baggage();
        }
        else {
            utils.stages.has_no_extra_baggage();
        }
    };
};
export const useTrackBaggageInPaxMobile = ({ hasBrandedFarePage }) => {
    const { isMobile, isDirect, isMeta, isFamily, isLongHaul } = useProfiler();
    return () => {
        if (!isMobile()) {
            return;
        }
        utils.trackWithDefaultStage();
        isDirect() && utils.stages.direct();
        isMeta() && utils.stages.meta();
        !hasBrandedFarePage && utils.stages.non_bf_flow();
        isFamily() && utils.stages.families();
        isLongHaul() && utils.stages.long_haul();
    };
};
export const useIsBaggageInPaxMobile = () => {
    const { isMobile } = useProfiler();
    return () => {
        if (!isMobile()) {
            return false;
        }
        return !!utils.trackWithDefaultStage();
    };
};
export default utils;
